import {OEM} from '../../models/oem.enum';
import {extractDomainFromUrl, isLocalhost, logger} from '../utils.service';

class OrbeeJdPowerService {
	isScriptLoaded = false;
	dealerDomain: string = '';
	providerToken: string = '';
	FULLPATH_TOKENS: Partial<Record<OEM, string>> = {
		[OEM.ACURA]: '7479pO31',
		[OEM.HONDA]: '4ex2bK3l',
	};

	public init(oems: string, url: string): void {
		if (oems && url) {
			this.dealerDomain = extractDomainFromUrl(url);
			this.providerToken = this.getProviderToken(oems);
			if (this.shouldLoadScript()) {
				this.loadScript();
			}
		}
	}

	private getProviderToken(oems: string): string {
		const oemsArr = oems.split(',');
		if (oemsArr.length === 1) {
			return this.FULLPATH_TOKENS[oemsArr[0] as OEM] as string;
		}
		return '';
	}

	private shouldLoadScript(): boolean {
		return !!this.providerToken && !!this.dealerDomain && !this.isScriptLoaded;
	}

	private loadScript(): void {
		if (isLocalhost()) {
			return;
		}
		try {
			const script = document.createElement('script');
			script.innerHTML = `
                (function(w,d,n,o,g) {
                    w.orbObject=w.orbObject||n;
                    if(!w[n]){
                        w[n]=function(){
                            return (w[n].q=w[n].q||[]).push(arguments);
                        };
                        w[n].q=w[n].q||[];
                    }
                    var namespace = "${this.dealerDomain}";
                    s=d.createElement(o);
                    m=d.getElementsByTagName(o)[0];
                    s.async=1;
                    s.src=g+"%3A"+namespace;
                    m.parentNode.insertBefore(s,m);
                })(window,document,"orb","script","//scripts.orb.ee/tms.js?sid=${this.providerToken}");
            `;
			document.head.appendChild(script);
			this.isScriptLoaded = true;
		} catch (error) {
			logger('Error loading Orbee script:', error);
		}
	}
}

export const orbeeJdPowerService = new OrbeeJdPowerService();
